import React from 'react';
import './Disclaimer.css';

const Disclaimer = ({domain,school_name,email}) => {
    let website_url=`https://${domain}/`;

    return (
        <div className="disclaimer-container">
            <div className='container'>

            <div className="disclaimer-header">Disclaimer</div>
            <h2 className="disclaimer-title">Disclaimer for {school_name}</h2>
            <p className="disclaimer-contact">
                If you require any more information or have any questions about our site’s disclaimer, please feel free to contact us by email at {email}.
            </p>

            <h3 className="disclaimer-section-title">Disclaimers for {school_name}</h3>
            <p className="disclaimer-content">
                All the information on this website – <a className="disclaimer-link" href={website_url} target="_blank" rel="noopener noreferrer">{website_url}</a> – is published in good faith and for general information purpose only. {school_name} does not make any warranties about the completeness, reliability and accuracy of this information. Any action you take upon the information you find on this website ({school_name}), is strictly at your own risk. {school_name} will not be liable for any losses and/or damages in connection with the use of our website.
            </p>

            <p className="disclaimer-content">
                From our website, you can visit other websites by following hyperlinks to such external sites. While we strive to provide only quality links to useful and ethical websites, we have no control over the content and nature of these sites. These links to other websites do not imply a recommendation for all the content found on these sites. Site owners and content may change without notice and may occur before we have the opportunity to remove a link which may have gone ‘bad’.
            </p>

            <p className="disclaimer-content">
                Please be also aware that when you leave our website, other sites may have different privacy policies and terms which are beyond our control. Please be sure to check the Privacy Policies of these sites as well as their “Terms of Service” before engaging in any business or uploading any information.
            </p>

            <h3 className="disclaimer-consent-title">Consent</h3>
            <p className="disclaimer-consent-content">
                By using our website, you hereby consent to our disclaimer and agree to its terms.
            </p>

            <h3 className="disclaimer-update-title">Update</h3>
            <p className="disclaimer-update-content">
                Should we update, amend or make any changes to this document, those changes will be prominently posted here.
            </p>
            </div>
            
        </div>
    );
};

export default Disclaimer;
